"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _GroupContext = require("./GroupContext");
var _style = require("./style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var Button = function Button(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, ["children"]);
  return /*#__PURE__*/_react.default.createElement(_GroupContext.Consumer, null, function (_ref2) {
    var name = _ref2.name,
      value = _ref2.value,
      onChange = _ref2.onChange,
      fullWidth = _ref2.fullWidth;
    var optional = {};
    if (value !== undefined) {
      optional.checked = rest.value === value;
    }
    if (typeof onChange === 'function') {
      optional.onChange = onChange;
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_style.Input, _extends({}, rest, {
      id: rest.id || rest.value,
      "aria-checked": optional.checked,
      type: "radio",
      name: name
    }, optional, {
      "data-key": "max-radio__input"
    })), /*#__PURE__*/_react.default.createElement(_style.GroupLabel, {
      htmlFor: rest.id || rest.value,
      disabled: rest.disabled,
      checked: optional.checked,
      fullWidth: fullWidth,
      small: rest.small,
      "data-key": "max-radio__label"
    }, children));
  });
};
var _default = Button;
exports.default = _default;